/* eslint-disable global-require, no-multi-spaces */

const configClient = require('./src/client/tailwind.config.client.js');
const standardColors = require('./tailwind.colors.js');
const clientColors = require('./src/client/tailwind.colors.client.js');
const customStatePlugin = require('./src/tailwind-plugins/custom-state');
const deviceModePlugin = require('./src/tailwind-plugins/device-mode');
const tailwindScreens = require('./tailwind.screens');

const publicMode = process.env.VUE_APP_ENV === 'public';

const config = {
    important: false, // 🐱‍💻 Removed to support RTE inline
    prefix: 'f-',

    theme: {
        // n.b. these are directly used by the FE code, but referenced within this same object wherever you see the theme() method being called
        standardColors,
        clientColors,

        extend: {
            ...configClient.theme,
        },

        alignItems: {
            start: 'start',
            center: 'center',
            end: 'end',
        },

        alignSelf: {
            start: 'start',
            center: 'center',
            end: 'end',
        },

        // custom
        aspectRatio: {
            none: '',
            '1/1': '',
            '16/9': '',
            '3/2': '',
            '4/3': '',
            '5/9': '',
        },

        // custom
        aspectRatioVideo: {
            none: '',
            '1/1': '',
            '16/9': '',
            '3/2': '',
            '4/3': '',
            '5/9': '',
        },

        backgroundAttachment: {
            fixed: 'fixed',
            local: 'local',
            scroll: 'scroll',
        },

        backgroundColor: (theme) => {
            return {
                ...theme('standardColors'),
                ...theme('clientColors'),
            };
        },

        // custom
        backgroundDisplay: {
            '': '',
        },

        backgroundPosition: {
            bottom: 'bottom',
            center: 'center',
            left: 'left',
            'left-bottom': 'left bottom',
            'left-top': 'left top',
            right: 'right',
            'right-bottom': 'right bottom',
            'right-top': 'right top',
            top: 'top',
        },

        backgroundRepeat: {
            'no-repeat': 'no-repeat',
            'repeat-x': 'repeat-x',
            'repeat-y': 'repeat-y',
            repeat: 'repeat',
        },

        backgroundSize: {
            auto: 'auto',
            cover: 'cover',
            contain: 'contain',
        },

        // custom
        blur: {
            0: '0px',
            1: '1px',
            2: '2px',
            3: '3px',
            4: '4px',
            5: '5px',
            6: '6px',
            7: '7px',
            8: '8px',
            9: '9px',
            10: '10px',
            20: '20px',
            40: '40px',
            80: '80px',
        },

        borderColor: theme => ({
            ...theme('standardColors'),
            ...theme('clientColors'),
            default: theme('colors.gray.300', 'currentColor'),
        }),

        borderRadius: {
            0: '0rem',
            0.0625: '0.0625rem', // 1px
            0.125: '0.125rem',   // 2px
            0.1875: '0.1875rem', // 3px
            0.25: '0.25rem',     // 4px
            0.3125: '0.3125rem', // 5px
            0.375: '0.375rem',   // 6px
            0.5: '0.5rem',       // 8px
            0.625: '0.625rem',   // 10px
            0.75: '0.75rem',     // 12px
            0.875: '0.875rem',   // 14px
            1: '1rem',           // 16px
            1.25: '1.25rem',     // 20px
            1.5625: '1.5625rem', // 25px
            1.875: '1.875rem',   // 30px
            2.5: '2.5rem',       // 40px
            3.125: '3.125rem',   // 50px
            3.75: '3.75rem',     // 60px
            4.375: '4.375rem',   // 70px
            5: '5rem',           // 80px
            5.625: '5.625rem',   // 90px
            6.25: '6.25rem',     // 100px
            '0/0': '0%',
            '1/10': '10%',
            '1/5': '20%',
            '3/10': '30%',
            '2/5': '40%',
            '1/2': '50%',
        },

        borderStyle: {
            solid: 'solid',
            dashed: 'dashed',
            dotted: 'dotted',
        },

        borderWidth: {
            0: '0px',
            1: '1px',
            2: '2px',
            3: '3px',
            4: '4px',
            5: '5px',
            8: '8px',
            10: '10px',
        },

        boxShadow: {
            none: 'none',
            light: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            sharp: `
            0 1px 1px rgba(0,0,0,0.12),
            0 2px 2px rgba(0,0,0,0.12),
            0 4px 4px rgba(0,0,0,0.12),
            0 8px 8px rgba(0,0,0,0.12)
            `,
            floating: '0px 7px 12px -5px rgba(0, 0, 0, 0.75)',
            'floating-light': '4px 8px 18px -8px rgba(0, 0, 0, 0.75)',
            outline: '0 0 0 3px rgba(0, 0, 0, 0.5)',
            inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
        },

        // custom
        boxed: {
            '': '',
        },

        container: {
            center: true,
            padding: '2rem',
        },

        // custom
        contrast: {
            0: '0%',
            25: '25%',
            50: '50%',
            75: '75%',
            100: '100%',
            125: '125%',
            150: '150%',
            175: '175%',
            200: '200%',
        },

        cursor: {
            auto: 'auto',
            default: 'default',
            pointer: 'pointer',
            wait: 'wait',
            text: 'text',
            move: 'move',
            'not-allowed': 'not-allowed',
        },

        display: {
            block: 'block',
            'inline-block': 'inline-block',
            inline: 'inline',
            table: 'table',
            'table-row': 'table-row',
            'table-cell': 'table-cell',
            hidden: 'hidden',
            flex: 'flex',
            'inline-flex': 'inline-flex',
        },

        // custom
        ellipses: {
            '': '',
        },

        flex: {
            1: '1 1 0%',
            auto: '1 1 auto',
            initial: '0 1 auto',
            none: 'none',
        },

        flexDirection: {
            row: 'row',
            'row-reverse': 'row-reverse',
            col: 'col',
            'col-reverse': 'col-reverse',
        },

        flexWrap: {
            'no-wrap': 'no-wrap',
            wrap: 'wrap',
            'wrap-reverse': 'wrap-reverse',
        },

        float: {
            left: 'left',
            right: 'right',
            none: 'none',
        },

        fontFamily: {
            default: 'Open Sans',
            heading: 'Helvetica Neue',
            accent: 'Merriweather',
        },

        fontSize: {
            0.5: '.5rem', // 8px
            0.625: '.625rem', // 10px
            0.75: '.75rem', // 12px
            0.8125: '.8125rem', // 13px
            0.875: '.875rem', // 14px
            0.9375: '.9375rem', // 15px
            1: '1rem', // 16px
            1.125: '1.125rem', // 18px
            1.25: '1.25rem', // 20px
            1.5: '1.5rem', // 24px
            1.75: '1.75rem', // 28px
            2: '2rem', // 32px
            2.25: '2.25rem', // 36px
            2.5: '2.5rem', // 40px
            3: '3rem', // 48px
            3.5: '3.5rem', // 56px
            4: '4rem', // 64px
            4.5: '4.5rem', // 72px
            6: '6rem', // 96px
            8: '8rem', // 128px
        },

        fontStyle: {
            italic: 'italic',
            'non-italic': 'normal',
        },

        fontWeight: {
            hairline: '100',
            thin: '200',
            light: '300',
            normal: '400',
            medium: '500',
            semibold: '600',
            bold: '700',
            extrabold: '800',
            black: '900',
        },

        // custom
        grayscale: {
            0: '0%',
            50: '50%',
            75: '75%',
            100: '100%',
        },

        height: {
            0: '0rem',
            0.0625: '0.0625rem', // 1px
            0.125: '0.125rem', // 2px
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            1.75: '1.75rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            7: '6rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            24: '24rem',
            32: '32rem',
            40: '40rem',
            48: '48rem',
            56: '56rem',
            64: '64rem',
            72: '72rem',
            80: '80rem',
            88: '88rem',
            96: '96rem',
            104: '104rem',
            112: '112rem',
            120: '120rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33333%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
            auto: 'auto',
            screen: '100vh',
        },

        inset: {
            0: '0',
            auto: 'auto',
            '1/2': '50%',
            '1/1': '100%',
        },

        justifyContent: {
            start: 'start',
            center: 'center',
            end: 'end',
            between: 'between',
            around: 'around',
        },

        letterSpacing: {
            tighter: '-0.05em',
            tight: '-0.025em',
            normal: '0em',
            wide: '0.025em',
            wider: '0.05em',
            widest: '0.1em',
        },

        lineHeight: {
            none: '1',
            tight: '1.25',
            snug: '1.375',
            normal: '1.5',
            relaxed: '1.625',
            loose: '2',
        },

        listStyleType: {
            none: 'none',
            disc: 'disc',
            decimal: 'decimal',
        },

        margin: {
            auto: 'auto',
            '-16': '-16rem',
            '-14': '-14rem',
            '-12': '-12rem',
            '-10': '-10rem',
            '-8': '-8rem',
            '-6': '-6rem',
            '-5': '-5rem',
            '-4': '-4rem',
            '-3': '-3rem',
            '-2.5': '-2.5rem',
            '-2': '-2rem',
            '-1.5': '-1.5rem',
            '-1.25': '-1.25rem',
            '-1': '-1rem',
            '-0.75': '-0.75rem',
            '-0.5': '-0.5rem',
            '-0.25': '-0.25rem',
            0: '0rem',
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            8: '8rem',
            9: '9rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            30: '30rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33333%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
        },

        maxHeight: {
            0: '0rem',
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            1.75: '1.75rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            7: '7rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            24: '24rem',
            32: '32rem',
            40: '40rem',
            48: '48rem',
            56: '56rem',
            64: '64rem',
            72: '72rem',
            80: '80rem',
            88: '88rem',
            96: '96rem',
            104: '104rem',
            112: '112rem',
            120: '120rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33333%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
            screen: '100vh',
        },

        maxWidth: {
            0: '0rem',
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            1.75: '1.75rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            7: '7rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            24: '24rem',
            32: '32rem',
            40: '40rem',
            48: '48rem',
            56: '56rem',
            64: '64rem',
            72: '72rem',
            80: '80rem',
            88: '88rem',
            96: '96rem',
            104: '104rem',
            112: '112rem',
            120: '120rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33333%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
            screen: '100vw',
            mob: tailwindScreens.mob.max,
            tab: tailwindScreens.tab.min,
            lap: tailwindScreens.lap.min,
            des: tailwindScreens.des.min,
        },

        minHeight: {
            0: '0rem',
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            1.75: '1.75rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            7: '6rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            24: '24rem',
            32: '32rem',
            40: '40rem',
            48: '48rem',
            56: '56rem',
            64: '64rem',
            72: '72rem',
            80: '80rem',
            88: '88rem',
            96: '96rem',
            104: '104rem',
            112: '112rem',
            120: '120rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33333%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
            screen: '100vh',
        },

        minWidth: {
            0: '0rem',
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            1.75: '1.75rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            7: '7rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            22: '22rem',
            24: '24rem',
            32: '32rem',
            40: '40rem',
            48: '48rem',
            56: '56rem',
            64: '64rem',
            72: '72rem',
            80: '80rem',
            88: '88rem',
            96: '96rem',
            104: '104rem',
            112: '112rem',
            120: '120rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/6': '16.66667%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33334%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
            screen: '100vw',
        },

        objectFit: {
            contain: 'contain',
            cover: 'cover',
            fill: 'fill',
            none: 'none',
            'scale-down': 'scale-down',
        },

        objectPosition: {
            'left-top': 'left top',
            top: 'top',
            'right-top': 'right top',
            left: 'left',
            center: 'center',
            right: 'right',
            'left-bottom': 'left bottom',
            bottom: 'bottom',
            'right-bottom': 'right bottom',
        },

        opacity: {
            0: '0',
            25: '0.25',
            50: '0.5',
            75: '0.75',
            95: '0.95',
            100: '1',
        },

        order: {
            first: '-9999',
            last: '9999',
            none: '0',
            normal: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
        },

        overflow: {
            auto: 'auto',
            hidden: 'hidden',
            scroll: 'scroll',
            visible: 'visible',
        },

        padding: {
            auto: 'auto',
            0: '0rem',
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33333%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
        },

        // custom
        placement: {
            none: '',
            top: '',
            'top-left': '',
            'top-right': '',
            left: '',
            middle: '',
            right: '',
            bottom: '',
            'bottom-left': '',
            'bottom-right': '',
            'fixed-fill': '',
            'fixed-top': '',
            'fixed-top-left': '',
            'fixed-top-right': '',
            'fixed-left': '',
            'fixed-middle': '',
            'fixed-right': '',
            'fixed-bottom': '',
            'fixed-bottom-left': '',
            'fixed-bottom-right': '',
            fill: '',
        },

        position: {
            static: 'static',
            relative: 'relative',
            fixed: 'fixed',
            absolute: 'absolute',
            sticky: 'sticky',
        },

        screens: {
            mob: tailwindScreens.mob,
            tab: tailwindScreens.tab,
            lap: tailwindScreens.lap,
            // the desktop breakpoint classes breaks the editor preview mode (since the viewport doesn't change)
            // ... so we only want to generated those classes for the public build
            ...(publicMode && { des: tailwindScreens.des }),
        },

        // custom
        skew: {
            50: '50deg',
            40: '40deg',
            30: '30deg',
            20: '20deg',
            10: '10deg',
            0: '0deg',
            '-10': '-10deg',
            '-20': '-20deg',
            '-30': '-30deg',
            '-40': '-40deg',
            '-50': '-50deg',
        },

        // custom
        sticky: {
            '': '',
        },

        // custom
        tabDockLocation: {
            top: 'top',
            right: 'right',
            bottom: 'bottom',
            left: 'left',
        },

        textAlign: {
            left: 'left',
            center: 'center',
            right: 'right',
        },

        textColor: (theme) => {
            return {
                ...theme('standardColors'),
                ...theme('clientColors'),
            };
        },

        textDecoration: {
            underline: 'underline',
            'line-through': 'line-through',
            'no-underline': 'no-underline',
        },

        textTransform: {
            uppercase: 'uppercase',
            lowercase: 'lowercase',
            capitalize: 'capitalize',
        },

        // custom
        transformOrigin: {
            'left-top': '',
            top: '',
            'right-top': '',
            left: '',
            center: '',
            right: '',
            'left-bottom': '',
            bottom: '',
            'right-bottom': '',
        },

        // custom
        transition: {
            0.1: '0.1',
            0.2: '0.2',
            0.3: '0.3',
            0.4: '0.4',
            0.5: '0.5',
            0.6: '0.6',
            0.7: '0.7',
            0.8: '0.8',
            0.9: '0.9',
            1: '1',
            1.25: '1.25',
            1.5: '1.5',
            1.75: '1.75',
            2: '2',
            2.5: '2.5',
            3: '3',
            4: '4',
            5: '5',
        },

        verticalAlign: {
            baseline: 'baseline',
            top: 'top',
            middle: 'middle',
            bottom: 'bottom',
            'text-top': 'text-top',
            'text-bottom': 'text-bottom',
        },

        visibility: {
            visible: 'visible',
            invisible: 'hidden',
        },

        whitespace: {
            normal: 'normal',
            'no-wrap': 'no-wrap',
            pre: 'pre',
            'pre-line': 'pre-line',
            'pre-wrap': 'pre-wrap',
        },

        width: {
            0: '0rem',
            0.0625: '0.0625rem', // 1px
            0.125: '0.125rem', // 2px
            0.25: '0.25rem',
            0.5: '0.5rem',
            0.75: '0.75rem',
            1: '1rem',
            1.25: '1.25rem',
            1.5: '1.5rem',
            1.75: '1.75rem',
            2: '2rem',
            2.5: '2.5rem',
            3: '3rem',
            4: '4rem',
            5: '5rem',
            6: '6rem',
            7: '7rem',
            8: '8rem',
            10: '10rem',
            12: '12rem',
            14: '14rem',
            16: '16rem',
            24: '24rem',
            32: '32rem',
            40: '40rem',
            48: '48rem',
            56: '56rem',
            64: '64rem',
            72: '72rem',
            80: '80rem',
            88: '88rem',
            96: '96rem',
            104: '104rem',
            112: '112rem',
            120: '120rem',
            '0/0': '0%',
            '1/20': '5%',
            '1/10': '10%',
            '3/20': '15%',
            '1/6': '16.66667%',
            '1/5': '20%',
            '1/4': '25%',
            '3/10': '30%',
            '1/3': '33.33334%',
            '7/20': '35%',
            '2/5': '40%',
            '9/20': '45%',
            '1/2': '50%',
            '11/20': '55%',
            '3/5': '60%',
            '13/20': '65%',
            '2/3': '66.66667%',
            '7/10': '70%',
            '3/4': '75%',
            '4/5': '80%',
            '17/20': '85%',
            '9/10': '90%',
            '19/20': '95%',
            '1/1': '100%',
            auto: 'auto',
            screen: '100vw',
            'min-content': 'min-content',
            'max-content': 'max-content',
        },

        wordBreak: {
            words: 'words',
            normal: 'normal',
        },

        zIndex: {
            auto: 'auto',
            '-2': '-2',
            '-1': '-1',
            0: '0',
            1: '1',
            10: '10',
            20: '20',
            30: '30',
            40: '40',
            50: '50',
            100: '100',
            200: '200',
            300: '300',
            400: '400',
            500: '500',
            1000: '1000',
        },

        // custom
        zoom: {
            0.1: '0.1',
            0.2: '0.2',
            0.3: '0.3',
            0.4: '0.4',
            0.5: '0.5',
            0.6: '0.6',
            0.7: '0.7',
            0.8: '0.8',
            0.9: '0.9',
            1: '1',
            1.1: '1.1',
            1.2: '1.2',
            1.3: '1.3',
            1.4: '1.4',
            1.5: '1.5',
            1.6: '1.6',
            1.7: '1.7',
            1.8: '1.8',
            1.9: '1.9',
            2: '2',
        },
    },

    // n.b. custom classes don't need the device mode variant, it only works for "real" Tailwind classes
    // ... the device mode functionality is added to custom classes by the responsive-class Sass mixin
    // ... additionally, the device mode plugin is only needed if the "responsive" variant is present
    variants: {
        alignContent: ['responsive', 'device-mode'],
        alignItems: ['responsive', 'device-mode'],
        alignSelf: ['responsive', 'device-mode'],
        appearance: [],
        aspectRatio: ['responsive'], // custom
        aspectRatioVideo: ['responsive'], // custom
        backgroundAttachment: [],
        backgroundDisplay: ['responsive'], // custom
        backgroundColor: ['responsive', 'device-mode', 'hover', 'selected', 'expanded', 'matching'],
        backgroundPosition: ['responsive', 'device-mode'],
        backgroundRepeat: ['responsive'],
        backgroundSize: ['responsive', 'device-mode'],
        blur: ['hover'], // custom
        borderCollapse: [],
        borderColor: ['hover', 'matching', 'selected'],
        borderRadius: ['responsive', 'device-mode'],
        borderStyle: [],
        borderWidth: ['device-mode', 'hover', 'matching', 'selected'],
        boxShadow: ['device-mode', 'hover'],
        boxed: ['responsive'], // custom
        contrast: ['hover'], // custom
        cursor: [],
        display: ['responsive', 'device-mode'],
        ellipses: [], // custom
        fill: [],
        flex: ['responsive', 'device-mode'],
        flexDirection: ['responsive', 'device-mode'],
        flexGrow: [],
        flexShrink: [],
        flexWrap: ['responsive', 'device-mode'],
        float: ['responsive'],
        fontSize: ['responsive', 'device-mode'],
        fontStyle: [],
        fontFamily: [],
        fontSmoothing: [],
        fontWeight: ['matching'],
        grayscale: ['hover'], // custom
        height: ['responsive', 'device-mode'],
        inset: ['responsive', 'device-mode'],
        justifyContent: ['responsive', 'device-mode'],
        letterSpacing: [],
        lineHeight: ['responsive'],
        listStylePosition: [],
        listStyleType: [],
        margin: ['responsive', 'device-mode'],
        maxHeight: ['responsive', 'device-mode'],
        maxWidth: ['responsive', 'device-mode'],
        minHeight: ['responsive', 'device-mode'],
        minWidth: ['responsive', 'device-mode'],
        negativeMargin: ['responsive', 'device-mode'],
        objectFit: ['responsive', 'device-mode'],
        objectPosition: ['responsive', 'device-mode'],
        opacity: ['responsive', 'device-mode', 'hover'],
        order: ['responsive', 'device-mode'],
        outline: [],
        overflow: ['responsive', 'device-mode'],
        padding: ['responsive', 'device-mode'],
        placement: ['responsive'], // custom
        pointerEvents: [],
        position: ['responsive', 'device-mode'],
        resize: [],
        skew: ['responsive'], // custom
        sticky: ['responsive'], // custom
        stroke: [],
        tabDockLocation: ['responsive'], // custom
        tableLayout: [],
        textAlign: ['responsive', 'device-mode'],
        textColor: ['responsive', 'device-mode', 'hover', 'selected', 'matching'],
        textDecoration: ['hover'],
        textTransform: [],
        transformOrigin: [], // custom
        transition: [], // custom
        userSelect: [],
        verticalAlign: [],
        visibility: ['responsive', 'device-mode'],
        whitespace: [],
        width: ['responsive', 'device-mode'],
        wordBreak: [],
        zIndex: [],
        zoom: ['responsive'], // custom
    },

    corePlugins: {},

    plugins: [
        deviceModePlugin.variant, // always load this as the first plugin
        customStatePlugin.variant,
        ...configClient.plugins,
    ],
};

// manually mix in each client config specific variant
Object.keys(configClient.variants).forEach((variantName) => {
    const variant = configClient.variants[variantName];

    config.variants[variantName].concat(variant);
});

// don't load the device mode plugin for the public build
if (publicMode) {
    Object.keys(config.variants).forEach((variantName) => {
        const variant = config.variants[variantName];
        const deviceModePluginIndex = variant.indexOf('device-mode');

        if (deviceModePluginIndex > -1) {
            variant.splice(deviceModePluginIndex, 1);
        }
    });

    config.plugins.splice(0, 1);
}

module.exports = config;
